import './Shop.css';
import ButtonCloseMainPopup from "../ButtonCloseMainPopup";

import {useTypedSelector} from "../../../hooks/useTypedSelector";
import NutakuBox from "./NutakuBox";
import {isTablet} from "react-device-detect";

function GemShopComponent(){

    const {isLoading, nutakuBoxes} = useTypedSelector(state => state.auth);

    let loadingClass = 'shopLoading';
    if(isLoading){
        loadingClass += ' shopLoadingVisible';
    }

    let shopNutakuBoxLineClass = 'shopNutakuBoxLine';

    if (isTablet){
        shopNutakuBoxLineClass += ' shopNutakuBoxLineTablet';
    }

    return <div className='main-popup-container'>
        <ButtonCloseMainPopup/>
        <div className={'offersTitle'}>
            <div className={'offersTitleText'}>Shop</div>
        </div>
        <div className={loadingClass}>
            <div id='l4'></div>
        </div>

        <div className={shopNutakuBoxLineClass}>
            <NutakuBox box={nutakuBoxes[0]}/>
            <NutakuBox box={nutakuBoxes[1]}/>
            <NutakuBox box={nutakuBoxes[2]}/>
        </div>

    </div>
}

export default GemShopComponent;